import { LensTheme } from '@diligentcorp/atlas-theme-mui-lens';
import { Chip, useTheme } from '@mui/material';
import React from 'react';

interface CategoryTypeBadgeProps {
  type: 'determined' | 'reported';
}

export const CategoryTypeBadge: React.FC<CategoryTypeBadgeProps> = ({
  type,
}) => {
  const { tokens } = useTheme<LensTheme>();
  const label = type === 'determined' ? 'Determined' : 'Reported';

  return (
    <Chip
      label={label}
      variant="outlined"
      size="small"
      data-testid={`category-type-badge-${type}`}
      sx={{
        borderRadius: '9999px',
        borderColor: tokens.semantic.color.type.muted.value,
        height: '24px',
      }}
    />
  );
};
